<template>
  <component :is="implementation" v-bind="{ ...props, ...$attrs }" />
</template>

<script lang="ts" setup>
import { LazyAccountNotVerifiedModal, LazyAccountTemporarilyLimitedModal } from '#components'

import type { AccountVerificationStatusModalProps } from '../utils/types'

import { useSendSafelyStore } from '../stores/sendSafely'

const props = defineProps<AccountVerificationStatusModalProps>()
const { isLoggedIn } = useAuth()
const { getHasUpload } = useSendSafelyStore()

const { result } = useUserDataQuery({
  enabled: isLoggedIn.value,
  fetchPolicy: 'cache-only',
})

const player = computed(() => result.value?.player)

const isPlayerWaiting = computed(() => {
  if (!player.value) return

  const hasSendSafelyUpload = getHasUpload(player.value.customerId)

  return (
    getIsAutomaticAgeVerificationPending(player.value.verifications) ||
    hasSendSafelyUpload ||
    getHasManualAgeVerification(player.value.verifications)
  )
})

const implementation = computed(() => {
  if (isPlayerWaiting.value) return LazyAccountTemporarilyLimitedModal
  return LazyAccountNotVerifiedModal
})
</script>
